import { getTvObject, tv } from '@costar-ui/cosmos';
import flexOptions from '../../common/flex-options/flex-options.esm.js';
import { focusRing } from '../../theme/styles/common.esm.js';

var variant = getTvObject({
  primary: ['bg-action-primary', 'text-on-action-primary', 'border-transparent', 'hover:bg-action-primary-hover', 'hover:text-on-action-primary-hover',
  //'hover:border-action-primary-hover',
  'pressed:bg-action-primary-active', 'pressed:text-on-action-primary-active',
  //'pressed:border-transparent',
  'disabled:bg-action-disabled',
  //'disabled:text-on-action-disabled',
  'disabled:border-disabled'],
  secondary: ['bg-action-base', 'text-on-action-base', 'border-action-base-inverse' /* @mitra review border assignment */, 'hover:bg-action-base-hover', 'hover:text-on-action-base-hover',
  //'hover:border-hover',
  'pressed:bg-action-base-active',
  //'pressed:text-on-action-neutral-active',
  //'pressed:border-active',
  'disabled:bg-action-disabled', 'disabled:text-on-action-disabled', 'disabled:border-disabled'],
  neutral: ['bg-action-neutral', 'text-on-action-neutral', 'border-transparent', 'hover:bg-action-neutral-hover', 'hover:text-on-action-neutral-hover',
  //'hover:border-action-neutral-hover',
  'pressed:bg-action-neutral-active', 'pressed:text-on-action-neutral-active',
  //'pressed:border-action-neutral-active',
  'disabled:bg-action-disabled', 'disabled:border-disabled'],
  'ghost-primary': ['text-action-primary', 'bg-transparent', 'border-transparent', 'hover:bg-action-primary-hover', 'hover:text-on-action-primary-hover', 'pressed:bg-action-primary-hover', 'pressed:text-on-action-primary-hover', 'active:bg-action-primary-active', 'active:text-on-action-primary-active'],
  'ghost-secondary': ['text-action-base-inverse', 'bg-transparent', 'border-transparent', 'hover:bg-action-base-hover', 'hover:text-on-action-base-hover', 'pressed:bg-action-base-hover', 'pressed:text-on-action-base-hover', 'active:bg-action-base-active', 'active:text-on-action-base-active'],
  'ghost-secondary-rounded': ['text-action-base-inverse', 'bg-transparent', 'border-transparent', 'hover:bg-action-base-hover', 'hover:text-on-action-base-hover', 'pressed:bg-action-base-hover', 'pressed:text-on-action-base-hover', 'active:bg-action-base-active', 'active:text-on-action-base-active', 'rounded-full', 'opacity-60'],
  'ghost-neutral': ['text-action-neutral', 'bg-transparent', 'border-transparent', 'hover:bg-action-base-hover', 'hover:text-on-action-base-hover',
  //'hover:border-action-neutral-hover',
  'pressed:bg-action-base-hover', 'pressed:text-on-action-base-hover',
  //'pressed:border-action-neutral-hover',
  'active:bg-action-base-active', 'active:text-on-action-base-active'
  //'active:border-action-neutral-active'
  ],
  // temp variant for list view footer
  'button-link': ['text-action-primary', 'bg-transparent', 'border-transparent', 'decoration-primary', 'hover:decoration-primary', 'hover:text-action-primary', 'hover:underline']
});
var buttonTV = getTvObject({
  extend: focusRing,
  base: ['relative', 'transition', 'rounded-sm', 'border', 'cursor-pointer', 'disabled:cursor-not-allowed', 'disabled:text-on-action-disabled', 'print:hidden'],
  variants: {
    variant: variant,
    color: {
      "default": ['bg', 'text'],
      'status-negative': ['bg-status-negative', 'text-on-status-negative'],
      'status-caution': ['bg-status-caution', 'text-on-status-caution'],
      'status-positive': ['bg-status-positive', 'text-on-status-positive']
    },
    size: {
      fit: ['px-2', 'py-1', 'h-fit', 'w-fit', 'text-p-16'],
      std: ['p-2', 'h-8', 'text-p-16'],
      sm: ['p-1', 'h-6', 'text-p-14'],
      'icon-fit': ['px-2', 'py-1', 'h-fit', 'w-fit', 'text-p-16'],
      'icon-std': ['p-1', 'h-8', 'w-8', 'text-p-16'],
      'icon-sm': ['p-1', 'h-6', 'w-6', 'text-p-14']
    },
    orientation: {
      vertical: ['flex', 'flex-col', 'gap-1', 'items-center', 'justify-center'],
      horizontal: ['flex', 'flex-row', 'gap-1', 'flex-nowrap', 'items-center', 'justify-center']
    },
    justify: flexOptions.variants.justify,
    alignItems: flexOptions.variants.alignItems,
    inheritFontSize: {
      "true": 'text-size-inherit'
    },
    inheritColor: {
      "true": 'text-inherit'
    },
    hoverMode: {
      none: ['hover:bg-transparent', 'hover:border-transparent'],
      opacity: ['hover:bg-transparent', 'hover:border-transparent', 'transition-opacity', 'hover:opacity-50']
    },
    noBorder: {
      "true": 'border-0'
    },
    // internal props only do not include in the public type
    nonInteractive: {
      "true": ['active:bg-transparent', 'active:border-transparent', 'pressed:bg-transparent', 'pressed:border-transparent', 'cursor-default']
    }
  },
  compoundVariants: [{
    variant: 'primary',
    nonInteractive: true,
    className: ['hover:bg-action-primary', 'hover:text-on-action-primary', 'hover:border-action-primary', 'pressed:bg-action-primary', 'pressed:text-on-action-primary', 'pressed:border-action-primary', 'outline-0', 'cursor-default']
  }]
});
var base = tv(buttonTV);
var buttonStyles = {
  base: base
};

export { buttonStyles, buttonTV };
//# sourceMappingURL=button.styles.esm.js.map
